/* unplugin-vue-components disabled */import script from "./PDFReport.vue?vue&type=script&lang=ts&setup=true"
export * from "./PDFReport.vue?vue&type=script&lang=ts&setup=true"

import "./PDFReport.vue?vue&type=style&index=0&id=a9ebe9ec&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9ebe9ec"]])

export default __exports__